<template>
    <div>
        <div class="columns">
            <div class="column" v-if="action == 'create'">
                <h2 class="title is-3">Создать приложение</h2>
            </div>
            <div class="column" v-if="action == 'update'">
                <h2 class="title is-3">Изменить приложение: {{ application.package_name }}</h2>
            </div>
        </div>

        <div class="columns">
            <div class="column is-6">
                <b-field label="Название">
                    <b-input v-model="application.package_name"></b-input>
                </b-field>
<!--                <b-field label="Keitaro token">-->
<!--                    <b-input v-model="application.keitaro_token"></b-input>-->
<!--                </b-field>-->
            </div>
        </div>

        <div class="columns">
            <div class="column">
                <h2 class="title is-3">Список офферов ({{ application.offers.length }})</h2>
            </div>
        </div>

        <div class="columns" v-if="application.id !== 1">
            <div class="column">
                <MultiplySelect
                    :model.sync="offerIds"
                    :options="offers"
                    field="name"
                    value="id"
                    :dense="true"
                    placeholder="Офферы"
                >
                </MultiplySelect>
            </div>
            <div class="column">
                <b-button
                    class="is-pulled-right"
                    type="is-primary"
                    icon-right="plus"
                    @click="addOffers">
                    Добавить
                </b-button>
            </div>
        </div>

        <div style="margin-top: 30px; margin-left: 30px">
            <div class="columns scrollable" ref="scrollable">
                <draggable
                    class="column"
                    v-model="application.offers"
                    draggable=".draggable-item"
                    v-bind="dragOptions"
                >
                    <transition-group type="transition">
                        <div class="draggable-item" v-for="offer in application.offers" :key="offer.id">
                            <div class="level">
                                <div class="level-item has-text-centered">
                                    <div>
                                        <i
                                            class="icon is-medium mdi mdi-dark mdi-menu"
                                            style="font-size: 24px;"
                                        ></i>
                                    </div>
                                </div>
                                <div class="level-item has-text-centered">
                                    <div>
                                        <p class="title is-4">{{ offer.name }}</p>
                                    </div>
                                </div>
                                <div class="level-item has-text-centered">
                                    <div class="image" style="width: 150px;">
                                        <img v-bind:src="offer.img_path" />
                                        <p
                                            class="heading"
                                            style="font-size: 14px; margin-top: 5px;"
                                        >
                                            Рейтинг: {{ offer.rate }}/5
                                        </p>
                                    </div>
                                </div>
                                <div class="level-item">
                                    <div>
                                        <p class="heading has-text-centered">Сумма займа</p>
                                        <p class="title is-4">до {{ offer.sum }} руб.</p>
                                    </div>
                                </div>
                                <div class="level-item has-text-centered">
                                    <div>
                                        <p class="heading">Срок займа</p>
                                        <p class="title is-4">до {{ offer.days }} дней</p>
                                    </div>
                                </div>
                                <div class="level-item has-text-centered">
                                    <div>
                                        <p class="heading">Процентная ставка</p>
                                        <p class="title is-4">от {{ offer.bet }}% в день</p>
                                    </div>
                                </div>
                                <div class="level-item has-text-centered" v-if="application.id !== 1">
                                    <div>
                                        <b-button icon-right="chevron-right" @click="edit(offer)"
                                        >Редактировать</b-button
                                        >
                                        <b-tooltip label="Скрыть">
                                            <b-button
                                                v-if="offer.show"
                                                icon-right="eye-outline"
                                                @click="switchShow(offer)"
                                            ></b-button>
                                            <b-button
                                                v-else
                                                icon-right="eye-off-outline"
                                                @click="switchShow(offer)"
                                            ></b-button>
                                        </b-tooltip>
                                        <b-tooltip label="Удалить">
                                            <b-button
                                                type="is-danger"
                                                icon-right="delete"
                                                @click="remove(offer)"
                                            >
                                            </b-button>
                                        </b-tooltip>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition-group>
                </draggable>
            </div>
        </div>

        <div class="columns" style="margin-top: 20px;">
            <div class="column">
                <b-button
                    class="is-pulled-right"
                    type="is-primary"
                    icon-right="check"
                    @click="save"
                >
                    Сохранить
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import MultiplySelect from "@/app/shared/components/form-inputs/MultiplySelect";

export default {
    name: "AdminUpdateLanding",
    components: {
        draggable,
        MultiplySelect,
    },
    created() {
        if (this.landingId && this.action == "update") {
            this.$store.dispatch("GET_APPLICATION_BY_ID", this.landingId);
        }
        else {
            this.application = {
                name: "",
                keitaro_token: "",
                offers: [],
            };
        }
        this.$store.dispatch("GET_OFFERS");
    },
    data() {
        return {
            offerIds:[],
        };
    },
    computed: {
        landingId() {
            return this.$route.params.id;
        },
        action() {
            return this.$route.name == "UpdateLanding" && this.landingId ? "update" : "create";
        },
        offers: {
            get() {
                return this.$store.getters.OFFERS;
            },
            set(value) {
                this.$store.commit("SET_OFFERS", value);
            },
        },
        application : {
            get() {
                return this.$store.getters.CURRENT_APPLICATION;
            },
            set(value) {
                this.$store.commit("SET_CURRENT_APPLICATION", value);
            },
        },
        dragOptions() {
            return {
                animation: 200,
                scroll: true,
                scrollSensitivity: 100,
                scrollSpeed: 10,
            };
        },
    },
    methods: {
        save() {
            switch (this.action) {
                case "create":
                    this.$store
                        .dispatch("CREATE_APPLICATION")
                        .then(() => {
                            this.$toaster.success("Новое приложение создано");
                            this.$router.push({ path: "/admin/landing_applications" });
                        })
                        .catch(() => {
                            this.$toaster.error("Неизвестная ошибка!");
                        });
                    break;
                case "update":
                    this.$store
                        .dispatch("UPDATE_APPLICATION", this.landingId)
                        .then(() => {
                            this.$toaster.success("Приложение изменено!");
                        })
                        .catch(() => {
                            this.$toaster.error("Неизвестная ошибка!");
                        });
                    break;
            }
        },
        addOffers() {
            this.application.offers.push(...this.offers.filter(offer => this.offerIds.includes(offer.id) || this.offerIds.includes(offer.default_offer_id)));
            this.offerIds = [];
        },
        edit(offer) {
            const route = this.$router.resolve({
                path: `/admin/offers/update/${offer.id}`,
            });
            window.open(route.href, "_blank");
        },
        remove(offer) {
            if (offer.app_id === 1) {
                const index = this.application.offers.indexOf(offer);
                this.application.offers.splice(index, 1);
                this.$toaster.success("Оффер удален успешно");
            }
            else {
                this.$store
                    .dispatch("DELETE_OFFER", offer.id)
                    .then(() => {
                        this.$toaster.success("Оффер удален");
                        this.$store.dispatch("GET_APPLICATION_BY_ID", this.landingId);
                    })
                    .catch(() => {
                        this.$toaster.error("Неизвестная ошибка!");
                    });
            }
        },
        switchShow(offer) {
            this.$store.dispatch("UPDATE_OFFER_SHOW", offer);
        },
    },
};
</script>

<style>
.b-numberinput input[type="number"] {
    text-align: center;
    width: 100%;
}
.draggable-item {
    border: 1px solid rgba(0, 0, 0, 0.125);
    padding: 10px;
    background-color: #fff;
}
</style>
